(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('IssueSignificance', IssueSignificance);

    IssueSignificance.$inject = ['$resource'];

    function IssueSignificance ($resource) {
        var resourceUrl =  'api/issue-significances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
